import React from "react";

// Shown in place of an admin page the signed-in admin hasn't been given access to
const AccessDenied: React.FC<{ moduleLabel: string }> = ({ moduleLabel }) => (
  <div className="admin-denied">
    <h1 className="admin-denied-title">{moduleLabel}</h1>
    <div className="admin-denied-card">
      <svg className="admin-denied-lock" viewBox="0 0 76 100" aria-hidden="true">
        <path d="M18 46V28a20 20 0 0 1 40 0v18" fill="none" stroke="#121417" strokeWidth="8" />
        <rect x="0" y="42" width="76" height="58" rx="12" fill="#fdb73e" />
        <rect x="34" y="62" width="8" height="20" rx="4" fill="#121417" />
      </svg>
      <h2 className="admin-denied-heading">You do not have access to this page</h2>
      <p className="admin-denied-text">
        You are not authorized to view {moduleLabel}.
        <br />
        If you believe you should have access, please contact your administrator to request the necessary permissions.
      </p>
    </div>
  </div>
);

export default AccessDenied;
